import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import TextAdjustLengthIcon from '@atlaskit/icon-lab/core/text-adjust-length';
import { fg } from '@atlaskit/platform-feature-flags';

import { MakeLongerIcon } from '../../../../icons/prompt/makeLonger';
import type { ConvoAiFeatureId } from '../../../../utils/request/types';
import { createInsertBelow, createReplace } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptionsFactory,
	EditorPluginAIConfigItemFactory,
} from '../../config-items';

const intentSchemaId = 'make_longer.json';

export const makeLonger: EditorPluginAIConfigItemFactory = (options) => {
	const featureId: ConvoAiFeatureId = fg('platform_editor_ai_adf_prompts_in_all_products')
		? 'make_longer_adf_gpt41mini'
		: 'make_longer';
	const adfPrompt = fg('platform_editor_ai_adf_prompts_in_all_products');

	return {
		key: CONFIG_ITEM_KEYS.MAKE_LONGER,
		title: aiConfigItemMessages.makeLongerTitle,
		description: aiConfigItemMessages.makeLongerDescription,
		icon: () => <MakeLongerIcon />,
		statusLozengeType: 'beta',
		intentSchemaId,
		featureId,
		adfPrompt,
		requiresTextualContent: adfPrompt,
		getBackendModel: () => 'assistance-service',
		showInRefineDropdown: true,
		actions: {
			empty: [
				createInsertBelow({ appearance: 'secondary', factoryOptions: options }),
				createReplace({ appearance: 'primary' }),
			],
			selection: [
				createInsertBelow({ appearance: 'secondary', factoryOptions: options }),
				createReplace({ appearance: 'primary' }),
			],
		},
		get nestingConfig() {
			if (options?.isInDocumentStreamingEnabled) {
				return {
					id: 'adjust-length',
					parentTestId: 'adjust-length',
					parentTitle: aiConfigItemMessages.adjustLengthNestingParentTitle,
					shortTitle: aiConfigItemMessages.adjustLengthNestingParentShortTitle,
					icon: () => <TextAdjustLengthIcon label="" spacing="spacious" />,
				};
			}
			return undefined;
		},
	};
};

export const makeLongerWithOptions: EditorPluginAIConfigItemWithOptionsFactory = (options) => ({
	config: makeLonger(options),
	triggers: { empty: { enabled: true, docMinSize: 1 }, selection: { enabled: true } },
});
